/* eslint-disable */
import { FaqEntryStatus } from '../dto/faq-entry-status';

export interface FaqEntryStatisticDto {
  faqEntryId: number;
  faqCategoryIds: number[];
  faqQuestion: string;
  publishedDate: Date;
  helpful: number;
  unhelpful: number;
  viewCount: number;
  status: FaqEntryStatus;
}

export const fixFaqEntryStatisticDtoFromJson = (dto?: FaqEntryStatisticDto | null): void => {
  if (!dto) {
    return;
  }
  dto.publishedDate = dto.publishedDate && new Date(dto.publishedDate);
};

export const fixFaqEntryStatisticDtoToJson = (dto?: FaqEntryStatisticDto | null): void => {
  if (!dto) {
    return;
  }
};
